const LIST_ITEM_DELIMITER = '\u00A0';

const sectionLookup = layout => {
  const sections = {};

  const crawl = (layout, description = {}) => {
    if (!Array.isArray(layout)) {
      console.error('Layout must be an array');
    }

    // eslint-disable-next-line
    layout.forEach((item, index) => {
      if (typeof item !== 'object') {
        console.error('Each item in the layout or fields must be an object');
      }

      const { parentType, parentName, parentConfig } = description;

      if (parentType === 'section') {
        if (!sections[parentName]) {
          sections[parentName] = { config: parentConfig, fields: [] };
        }
      }

      if (item.type === 'section' || item.type === 'tab') {
        const { fields, type, label, ...rest } = item;

        return crawl(fields, { parentType: type, parentName: label, parentConfig: rest });
      }

      if (parentType === 'section') {
        sections[parentName].fields.push(item.name);
      } else if (item.section) {
        if (!sections[item.section]) {
          sections[item.section] = { config: {}, fields: [] };
        }

        sections[item.section].fields.push(item.name);
      } else {
        sections[`_${index}`] = { config: {}, fields: [item.name] };
      }
    });
  };

  crawl(layout);
  return sections;
};

function bytesToSize(bytes) {
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) {
    return '0 bytes';
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`;
}

const getListItemId = function (val = '') {
  if (!val || !val.split) {
    return val;
  }
  return val.split(`:${LIST_ITEM_DELIMITER}`)[0];
};

export { bytesToSize, sectionLookup, getListItemId, LIST_ITEM_DELIMITER };
